const INITIAL_STATE = {
  data: {},
  errors: {},
};
    
const getViewByWorkOrder = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case "GET_VIEW_BY_WORK_ORDER_LIST":
    return { ...INITIAL_STATE, data: action.data };
  case "GET_VIEW_BY_WORK_ORDER_LIST_FAILED":
    return { ...INITIAL_STATE, errors: action.data };
  default:
    return { ...state };
  }
};
    
export default getViewByWorkOrder;
    